'use client'

import { m, useScroll, useSpring, useTransform } from 'framer-motion'
import { useRef } from 'react'

interface FocusStep {
  title: string
  desc?: string
  description?: string
}

const ProcessItem = ({
  step,
  index,
  gradient,
}: {
  step: FocusStep
  index: number
  gradient: string
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  })

  const opacity = useTransform(scrollYProgress, [0.4, 0.5, 0.6], [0.3, 1, 0.3])
  const scale = useTransform(scrollYProgress, [0.4, 0.5, 0.6], [0.95, 1.05, 0.95])
  const blur = useTransform(scrollYProgress, [0.4, 0.5, 0.6], [5, 0, 5])

  const activeOpacity = useSpring(opacity, { stiffness: 100, damping: 20 })
  const activeScale = useSpring(scale, { stiffness: 100, damping: 20 })
  const activeBlur = useSpring(blur, { stiffness: 100, damping: 20 })

  return (
    <m.div
      ref={ref}
      style={{ opacity: activeOpacity, scale: activeScale, filter: `blur(${activeBlur})` }}
      className={`flex flex-col items-center gap-12 py-12 md:flex-row ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
    >
      <div className="flex-1 text-center md:text-right">
        <div className="bg-gradient-to-br from-white/10 to-transparent bg-clip-text text-[8rem] leading-none font-bold text-transparent select-none md:text-[10rem]">
          0{index + 1}
        </div>
      </div>

      <div className="flex-1">
        <div className="group relative overflow-hidden rounded-[40px] border border-white/10 bg-white/[0.03] p-8 shadow-2xl backdrop-blur-xl md:p-12">
          <div
            className={`absolute top-0 left-0 h-[2px] w-full bg-gradient-to-r ${gradient} opacity-50`}
          />

          <h4 className="home-card-title mb-6 text-white">{step.title}</h4>
          <p className="home-subnote leading-relaxed text-gray-300">
            {step.desc || step.description || ''}
          </p>
        </div>
      </div>
    </m.div>
  )
}

export default function ProcessFocusList({
  process,
  gradient,
}: {
  process: FocusStep[]
  gradient: string
}) {
  return (
    <section className="home-section relative">
      <div className="relative z-10 mb-12 px-4 text-center">
        <h3 className="home-title mb-2">Наши принципы</h3>
        <p className="home-lead text-gray-400">Фундамент качества</p>
      </div>

      <div className="home-container relative">
        <div className="absolute top-0 bottom-0 left-4 w-[2px] -translate-x-1/2 bg-white/5 md:left-1/2 md:transform-none" />

        <div className="relative">
          {process.map((step, i) => (
            <ProcessItem key={i} step={step} index={i} gradient={gradient} />
          ))}
        </div>
      </div>
    </section>
  )
}
